@if (facade.multiSavingsPlanError$ | async; as multiSavingsPlanError) {
  <div class="row mt-4 mb-4">
    <div class="col">
      <div class="error-container">
        @if (multiSavingsPlanError?.errors?.length >= 1) {
          <div>{{ multiSavingsPlanError.message }}</div>
          <ul class="list" data-zid="error-list">
            @for (error of multiSavingsPlanError?.errors; track $index) {
              <li>ISIN: {{ error.isin }} - {{ error.message }}</li>
            }
          </ul>
        } @else {
          <div class="mb-3" data-zid="single-error">{{ multiSavingsPlanError.message }}</div>
        }
      </div>
    </div>
  </div>
}
